var App = App || {};

App.RichText = (function ($) {
    "use strict";

    function init() {
        const richTexts = $(".rich-text");

        if (richTexts.length) {
            richTexts.each(function () {
                //TinyMCE strips out role, but allows data- attributes, so we use JS to add this where needed
                $(this).find("table[data-role]").each(function () {
                    $(this).attr("role", $(this).attr("data-role"));
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RichText.init();
});